module.exports = __webpack_public_path__ + "img/bedrooms_3_tn.37c7172b.jpg";